/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import './AddVersionModal.css';

class AutoLogoutModal extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      isOpenMAL: props.isOpenMAL,
      seconds: 10,
    };
    this.countDown = this.countDown.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMAL } = this.props;

    if (prevProps.isOpenMAL !== isOpenMAL) {
      this.setState({
        isOpenMAL,
      }, () => {
        if (isOpenMAL) {
          this.timer = setInterval(() => {
            this.countDown();
          }, 1000);
        }
      });
    }
  }

  countDown() {
    const { seconds } = this.state;
    if (seconds > 0) {
      this.setState({
        seconds: seconds - 1,
      });
    } else {
      this.closeModal();
      clearInterval(this.timer);
    }
  }

  closeModal() {
    this.setState({
      isOpenMAL: false,
    });
    clearInterval(this.timer);
    this.props.closeModal();
  }

  render() {
    const { seconds } = this.state;
    const { t } = this.props;
    return (
      <Modal open={this.state.isOpenMAL} onClose={this.closeModal}>
        <div className="modal_popup_wrap confirm_wrap">
          <div className="modal_popup_box confirm_box">
            <div className="modal_popup confirm">
              <h2 className="title">{t('modal.title.attention')}</h2>
              <p className="text">
                {t('modal.message.auto_logout')}
              </p>
              <p className="small_text">
                {t('modal.message.auto_logout_close', { seconds })}
              </p>
              <div className="button_wrap">
                <a
                  className="center_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  {t('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default WithRouter(withTranslation()(AutoLogoutModal));
